import { useCallback, useState } from "react";
import type { AddCostPanelMode } from "../components/CostPanel/CostPanel.types";

const useAddCostPanelLifecycle = () => {
  const [panelActive, setPanelActive] = useState(false);
  const [mode, setMode] = useState<AddCostPanelMode>("inputs");

  const openPanel = useCallback(() => {
    setMode("inputs");
    setPanelActive(true);
  }, []);

  const closePanel = useCallback(() => {
    setPanelActive(false);
  }, []);

  const toggleFormulaMode = useCallback(() => {
    setMode((current) => (current === "formula" ? "inputs" : "formula"));
  }, []);

  const enterEditDimensionValues = useCallback(() => {
    setMode("editDimensionValues");
  }, []);

  const exitToInputs = useCallback(() => {
    setMode("inputs");
  }, []);

  return {
    panelActive,
    mode,
    openPanel,
    closePanel,
    toggleFormulaMode,
    enterEditDimensionValues,
    exitToInputs,
  };
};

export default useAddCostPanelLifecycle;
